module.exports = __webpack_public_path__ + "img/icon_category_05.4106af87.svg";